import { render, staticRenderFns } from "./Shrubs.vue?vue&type=template&id=6e7cba34&scoped=true&"
import script from "./Shrubs.vue?vue&type=script&lang=js&"
export * from "./Shrubs.vue?vue&type=script&lang=js&"
import style0 from "./Shrubs.vue?vue&type=style&index=0&id=6e7cba34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7cba34",
  null
  
)

export default component.exports